import HttpCacheVolatileAdapter from './HttpCacheVolatileAdapter'
import HttpCacheLocalStorageAdapter from './HttpCacheLocalStorageAdapter'
import { getData, setData } from '../../LocalStorage/dataInteractors'

export default [
  new HttpCacheVolatileAdapter(),
  new HttpCacheLocalStorageAdapter(getData, setData),
]
